<template>
  <page-view>
    <div slot="pageRight" class="pb90">
      <div class="flex menu_box mb20">
        <div v-for="(v,i) in menuList" :key="i" class="menu_item" :class="{'active': activeMenu===v.code}" @click="changeMenu(v)">{{ v.name }}</div>
      </div>
      <div class="status-box bg-white plr20 ptb15 border-radius-4">
        <a-form-model layout="vertical">
          <a-row type="flex" :class="{'flex-justify': activeMenu==='1'}">
            <a-col v-if="activeMenu==='1'||activeMenu==='3'" :span="4" class="mr30">
              <a-form-model-item label="订单号" :colon="false">
                <a-input v-model="queryParams.ConsignOrderNo" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="activeMenu==='1'" :span="4" class="mr30">
              <a-form-model-item label="PO No" :colon="false">
                <a-input v-model="queryParams.PONO" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="activeMenu==='1'||activeMenu==='2'||activeMenu==='3'" :span="4" class="mr30">
              <a-form-model-item label="物料号" :colon="false">
                <a-input v-model="queryParams.OwnerCarogoCode" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="activeMenu==='1'||activeMenu==='2'||activeMenu==='3'" :span="4" class="mr30">
              <a-form-model-item label="批次号" :colon="false">
                <a-input v-model="queryParams.BatchNo" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="activeMenu==='1'||activeMenu==='2'||activeMenu==='3'" :span="4" class="" :class="{'mr30': activeMenu==='3'}">
              <a-form-model-item label="物料名称" :colon="false">
                <a-input v-model="queryParams.CargoNameCn" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="activeMenu==='3'" :span="5" style="flex:1;">
              <a-form-model-item label="入库日期">
                <a-range-picker
                  v-model="queryParams.dateRange"
                  @change="handleDateRangeChange"
                  allowClear
                />
              </a-form-model-item>
            </a-col>
            <a-col v-if="activeMenu==='5'" :span="5" class="mr30">
              <a-form-model-item label="集装箱号" :colon="false">
                <a-input v-model="queryParams.CTNNo" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="activeMenu==='5'" :span="5" class="mr30">
              <a-form-model-item label="主提单号" :colon="false">
                <a-input v-model="queryParams.MBLNo" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="activeMenu==='4'||activeMenu==='5'" :span="5" class="mr30">
              <a-form-model-item label="进仓编号" :colon="false">
                <a-input v-model="queryParams.ConsignOrderNo" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row type="flex" class="mt10" :class="{'flex-justify': activeMenu==='1', 'flex-jend': activeMenu!=='1'}">
            <a-col v-if="activeMenu==='1'" :span="5" class="mr30">
              <a-form-model-item label="入库日期">
                <a-range-picker
                  v-model="queryParams.dateRange"
                  @change="handleDateRangeChange"
                  allowClear
                />
              </a-form-model-item>
            </a-col>
            <div class="btn-box " :class="{'pt30': activeMenu==='1', 'pt10': activeMenu!=='1'}">
              <a-button type="primary" @click="search">
                查询
              </a-button>
              <a-button class="ml15" @click="reset">
                重置
              </a-button>
              <!-- <a-button class="ml15" @click="exportfn">
                导出
              </a-button> -->
            </div>
          </a-row>
        </a-form-model>
      </div>
      <div class="mt20">
        <!-- 订单列表 -->
        <a-spin :spinning="loading">
          <div v-if="dataList.length>0">
            <CfsTableList
              v-if="activeMenu==='4'"
              ref="cfsTableList"
              :activeMenu="activeMenu"
              :dataList="dataList"
              :consignOrderNo="queryParams.ConsignOrderNo"
              :orderTotal="orderTotal" />
            <CfsFileTableLList v-else-if="activeMenu==='5'" ref="cfsTableList" :activeMenu="activeMenu" :dataList="dataList" />
            <table-list v-else ref="tableList" :activeMenu="activeMenu" :showPONo="showPONo" :dataList="dataList" />
          </div>
          <div v-else class="empty-box bg-white border-radius-4 flex flex-acenter flex-jcenter">
            <a-empty />
          </div>
        </a-spin>
      </div>
      <a-row v-if="dataList.length>0&&activeMenu!=='5'&&activeMenu!=='4'" class="bottom-total">
        <div class="flex plr10 flex-justify flex-acenter" style="height:60px;">
          <div class="calitem cmain ft14 fw700 pl20 pr5" style="width:10%;">{{ activeMenu==='2'?'总计：':'订单总计：' }}</div>
          <div class="calitem plr5" style="width:11%;"> </div>
          <div class="calitem plr5" style="width:7%;"> </div>
          <div class="calitem plr5" style="width:9%;"> </div>
          <div class="calitem cmain ft14 fw700 tc plr5" style="width:7%;">{{ (orderTotal.totalQty || 0).toFixed(2) }}</div>
          <div class="calitem plr5" style="width:7%;">  </div>
          <div class="calitem cmain ft14 fw700 tc plr5" style="width:9%;">{{ (orderTotal.totalBaseQty || 0).toFixed(2) }}</div>
          <div class="calitem plr5" style="width:7%;">  </div>
          <div v-if="activeMenu!=='2'" class="calitem cmain ft14 fw700 tc plr5" style="width:9%;">{{ (orderTotal.totalNetWeight || 0).toFixed(2) }}</div>
          <div class="calitem cmain ft14 fw700 tc plr5" style="width:9%;">{{ (orderTotal.totalGrossWeight || 0).toFixed(2) }}</div>
          <div v-if="showPONo" class="calitem plr5" style="width:7%;"> </div>
          <div class="calitem plr5" style="width:8%;"> </div>
        </div>
      </a-row>
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import TableList from './modules/tableList'
import CfsTableList from './modules/cfsTableList'
import CfsFileTableLList from './modules/cfsFileTableLList'
import { DCInbound, DCStock, DCOutbound, CFSInbound, CFSPhoto, DCStockExport } from '@/api/order'
import { USER_INFO } from '@/store/mutation-types'
import message from 'ant-design-vue/es/message'
export default {
  name: 'StorageSearch',
  components: { PageView, TableList, CfsTableList, CfsFileTableLList },
  data () {
    return {
      activeMenu: '1',
      menuList: [
        { code: '1', name: 'DC入库查询' },
        { code: '2', name: 'DC库存查询' },
        { code: '3', name: 'DC出库查询' },
        { code: '4', name: 'CFS入库查询' },
        { code: '5', name: 'CFS照片查询' }
      ],
      queryParams: {},
      orderTotal: {
        totalQty: 0,
        totalBaseQty: 0,
        totalNetWeight: 0,
        totalGrossWeight: 0
      },
      jobType: '',
      userData: '',
      dataList: [],
      orgPortList: [],
      orgPortListPod: [],
      loading: false,
      showPONo: true
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    }
  },
  created () {
    this.jobType = this.$route.params.type
  },
  methods: {
    exportfn () {
      this.queryParams.ConsignID = this.userInfo.CACode
      DCStockExport(this.queryParams).then(res => {
        console.log(res)
      })
    },
    search () {
      this.queryParams.ConsignID = this.userInfo.CACode
      // this.queryParams.ConsignID = 201808015989
      this.loading = true
      switch (this.activeMenu) {
        case '1':
          DCInbound(this.queryParams).then(res => {
            this.dataList = res.Data.dataLists || []
            this.calTotal()
            this.showPONo = true
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
          break
        case '2':
          DCStock(this.queryParams).then(res => {
            this.dataList = res.Data.dataLists || []
            this.calTotal()
            this.loading = false
            this.showPONo = false
          }).catch(() => {
            this.loading = false
          })
          break
        case '3':
          DCOutbound(this.queryParams).then(res => {
            this.dataList = res.Data.dataLists || []
            this.calTotal()
            this.showPONo = false
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
          break
        case '4':
          CFSInbound(this.queryParams).then(res => {
            this.dataList = res.Data.CFSResponse1 || []
            this.calTotalCFS()
            this.showPONo = false
            this.loading = false
          }).catch(() => {
            message.warning('请输入完整的进仓编号')
            this.loading = false
          })
          break
        case '5':
          if (this.queryParams.CTNNo || this.queryParams.MBLNo || this.queryParams.ConsignOrderNo) {
            CFSPhoto(this.queryParams).then(res => {
              const list = res.Data.CFSPhotoResponse || []
              list.forEach(v => {
                v.checked = false
              })
              this.dataList = list
              this.calTotal()
              this.showPONo = false
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
            break
          } else {
            this.loading = false
            message.warning('请输入查询条件')
            break
          }
        default:
          this.loading = false
          break
      }
    },
    reset () {
      this.queryParams = {}
      this.dataList = []
      // this.search()
    },
    calTotal () {
      this.orderTotal.totalQty = 0
      this.orderTotal.totalBaseQty = 0
      this.orderTotal.totalNetWeight = 0
      this.orderTotal.totalGrossWeight = 0
      if (this.dataList.length <= 0) return
      this.dataList.forEach(vv => {
        vv.totalQty = 0
        vv.totalBaseQty = 0
        vv.totalNetWeight = 0
        vv.totalGrossWeight = 0
        vv.DCR.forEach(v => {
          vv.totalQty += +v.Qty
          vv.totalBaseQty += +v.BaseQty
          vv.totalNetWeight += +v.NetWeight
          vv.totalGrossWeight += +v.GrossWeight
        })
        this.orderTotal.totalQty += vv.totalQty
        this.orderTotal.totalBaseQty += vv.totalBaseQty
        this.orderTotal.totalNetWeight += vv.totalNetWeight
        this.orderTotal.totalGrossWeight += vv.totalGrossWeight
      })
    },
    calTotalCFS () {
      this.orderTotal.totalQty = 0
      this.orderTotal.totalVolume = 0
      if (this.dataList.length <= 0) return
      this.dataList.forEach(v => {
        this.orderTotal.totalQty += +v.Qty
        this.orderTotal.totalVolume += +v.Volume
      })
    },
    handleChange (value) {

    },
    changeMenu (item) {
      if (this.activeMenu === item.code) return
      this.activeMenu = item.code
      this.queryParams = {}
      this.dataList = []
      // this.search()
    },
    handleDateRangeChange (date, dateStr) {
      console.log(dateStr)
      this.queryParams.BizDate_B = dateStr[0]
      this.queryParams.BizDate_E = dateStr[1]
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../styles/var.less";
.empty-box {
  height: 200px;
}
.menu_box {
  .menu_item {
    height: 36px;
    line-height: 36px;
    text-align: center;
    padding: 0 20px;
    margin-right: 10px;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      color: @main-color;
    }
    &.active {
      background-color: @main-color;
      color: #fff;
    }
  }
}
.bottom-total {
  height: 60px;
  width: 100%;
  padding-left: 95px;
  padding-right: 25px;
  background-color: #fff;
  box-shadow: 0px -4px 10px 0px rgba(0,0,0,0.1);
  position: fixed;
  bottom: 0;
  right: 0;
}
.calitem {
  min-height: 20px;
}
</style>
